<div
  class="vertical-bars-item stats"
  [ngClass]="{ 'vertical-bars-item--loading': loading }"
>
  <div class="vertical-bars-item__header">
    <h1 class="vertical-bars-item__title">
      {{ data$()?.title }}
    </h1>
    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        class="vertical-bars-item__expand"
        (click)="downloadXlsx()"
      >
        <mat-icon>file_open</mat-icon>
      </button>
      <button
        mat-icon-button
        class="vertical-bars-item__expand"
        (click)="openModal()"
      >
        <mat-icon>fullscreen</mat-icon>
      </button>
    </div>
  </div>
  <div class="vertical-bars-item__body">
    <div
      class="vertical-bars-item__chart"
      [style.height]="chartService$.recommendedHeight$() + 'px'"
    >
      <canvas
        baseChart
        [type]="chartService$.barChartType"
        [data]="chartService$.barChartData$()"
        [options]="chartService$.barChartOptions"
        [plugins]="chartService$.barChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>
    </div>

    @if (loading) {
      <mat-spinner
        class="vertical-bars-item__spinner"
        [diameter]="75"
      ></mat-spinner>
    }
  </div>

  <!-- <div class="vertical-bars-item__footer">
    <a [routerLink]="data$()?.hyperlink">
      {{ data$()?.hyperlinkText || "View " + data$()?.title }}
    </a>
  </div> -->
</div>
